import { render, staticRenderFns } from "./BaseSplash.vue?vue&type=template&id=07069692&scoped=true&"
import script from "./BaseSplash.vue?vue&type=script&lang=js&"
export * from "./BaseSplash.vue?vue&type=script&lang=js&"
import style0 from "./BaseSplash.vue?vue&type=style&index=0&id=07069692&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07069692",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib'
import { VParallax } from 'vuetify/lib'
installComponents(component, {VLayout,VParallax})
